import api from '@shared/services/api.js';

export const getAgencies = async organizationId => {
  return api.get(`/api/v1/organizations/${organizationId}/agencies/`);
};
